import styled from "styled-components";

export const DivFooter = styled.footer`
    background-color: black;
    color: darkgoldenrod;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 55px 0 55px 0;

    a{
        text-decoration: none;
        color: #dDa92c;
    }
`

